import React, { useCallback, useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import APIService from 'src/utils/APIService';
import { TRIGGER_TITLE_RESULT_CHILD_COLUMNS } from 'src/constants/dataGridColumns';
import NoDataFound from 'src/components/Shared/Table/NoDataFound';
import ORMDataGridV2 from 'src/components/Shared/Table/ORMDataGridV2';
import RenderSpinner from 'src/components/Spinner';
import ORMModal from 'src/components/Shared/UI/ORMModal';

export default function TriggerTitleResultsModal({ show, id, handleClose }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [state, setState] = useState({ error: false, data: [], isLoading: true });

  const fetchData = useCallback(async () => {
    const response = await APIService.get(`/triggertitle/result/${id}`);
    const { status, data } = response || {};
    if (status === 200) {
      setState({
        data: data.triggerTitles,
        error: false,
        isLoading: false,
      });
    } else {
      setState({
        data: [],
        error: true,
        isLoading: false,
      });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const { error, data, isLoading } = state;

  const renderModal = () => {
    if (isLoading) {
      return (
        <Box
          sx={{
            height: 300,
          }}
        >
          <RenderSpinner message='Fetching Trigger Title Results, Please wait' isOverlay={false} />
        </Box>
      );
    }
    if (data?.length === 0) {
      return (
        <Box
          sx={{
            height: 300,
          }}
        >
          <NoDataFound message='No Data Found' />
        </Box>
      );
    }
    if (error) {
      return 'Something went wrong!';
    } else {
      return (
        <ORMDataGridV2
          isDefaultCompact={true}
          columns={TRIGGER_TITLE_RESULT_CHILD_COLUMNS}
          rows={data}
          toolbarOptions={['COLUMNS', 'FILTER', 'DENSITY', 'EXPORT', 'SEARCH']}
          uniqueRowId='primary_isbn'
          variant='secondary'
          height={isMobile ? '70vh' : '600px'}
          pagination
        />
      );
    }
  };

  return (
    <ORMModal open={show} title={'Trigger Title Results'} content={renderModal()} onClose={handleClose} maxWidth='xl' />
  );
}
